import { RouteConfig } from 'vue-router';
import Overview from '@/views/managecompanychildren/CompanyChildrenOverview.vue';

const routes: Array<RouteConfig> = [
	{
		path: '/companychildren/',
		name: 'companychildren',
		component: Overview,
	},
];

export default routes;
